'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.recommendRandomSort = void 0;
var _require = require('./index'), randomSort = _require.randomSort, recommendRandomSort = function (r, o) {
        if ('[object Array]' !== Object.prototype.toString.call(r))
            return r;
        if (r.length <= o)
            return r;
        var e = [], t = 0, n = r.filter(function (r) {
                return 0 === r.top && 0 === r.fix;
            }), i = r.map(function (r, e) {
                return 0 === r.top && 0 === r.fix ? e : (e < o - 1 && t++, null);
            });
        i = i.filter(function (r) {
            return null !== r;
        }), n = randomSort(n, o - t);
        for (var u = 0, d = 0; d < o; d++)
            i.includes(d) ? (e[d] = n[u], u++) : e[d] = r[d];
        return e;
    };
exports.recommendRandomSort = recommendRandomSort;